var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInWhite({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 36C27.9411 36 36 27.9411 36 18C36 8.05887 27.9411 0 18 0C8.05887 0 0 8.05887 0 18C0 27.9411 8.05887 36 18 36ZM13.0619 14.9929V26.2997H9.30708V14.9929H13.0619ZM13.3094 11.4962C13.3094 12.5812 12.4944 13.4495 11.1853 13.4495L11.185 13.4494H11.1607C9.90048 13.4494 9.08576 12.5811 9.08576 11.4961C9.08576 10.3865 9.92508 9.54246 11.2102 9.54246C12.4944 9.54246 13.2849 10.3865 13.3094 11.4962ZM18.8948 26.2997H15.1403L15.1402 26.3001C15.1402 26.3001 15.1895 16.054 15.1405 14.9933H18.8951V16.5938C19.3943 15.8235 20.2875 14.7279 22.2792 14.7279C24.7495 14.7279 26.6016 16.3439 26.6016 19.8167V26.2997H22.8472V20.2515C22.8472 18.7314 22.3035 17.6946 20.9452 17.6946C19.9077 17.6946 19.2899 18.3938 19.0185 19.0693C18.9193 19.3103 18.8948 19.6487 18.8948 19.9862V26.2997Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInWhite);
export default __webpack_public_path__ + "static/media/inWhite.9ab8bdc21f13fc45af27f6c45c760bbf.svg";
export { ForwardRef as ReactComponent };